<section class="xl:container xl:m-auto xl:pl-[15px] xl:pr-[15px]" id="aboutauthor">
    <div class="p-6 md:px-[70px] md:py-12 bgbanner bg-cover bg-center bg-[#F5F1F1]">
        <h3 class="text-32 text-black font-libre-regular mb-6">
            About the Author
        </h3>
        <div class="flex mb-6">
            <div>
                <h4 class="text-18 text-black mb-[6px]">Shriram Wealth</h4>
                <!-- <p class="text-14 text-[#666666] mb-0">
                    Chief Operating Officer & Head of Product
                </p> -->
            </div>
        </div>
        <p class="text-14 md:text-16 text-black mb-0">
            With a strong presence in financial services, Shriram Wealth is a team focused on investments and wealth
            management. It specializes in wealth creation, portfolio management, and managing investments across
            different market conditions.
        </p>
    </div>
</section>